import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { ToggleButton } from "./../../toolbars-ui";
import { RemovePreviewIcon } from "../icons";
const RemovePreviewButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      Icon: RemovePreviewIcon,
      onClick: () => toolbarItem.commands?.click(),
      dataHook,
      tooltip: t("LinkPreview_RemovePreview_Tooltip")
    }
  );
};
export {
  RemovePreviewButton
};
//# sourceMappingURL=RemovePreviewButton.js.map
